/*
 * Unlock toast — slides down briefly when one or more new hats unlock.
 */

import { $ } from '@/ui/modal';
import type { Hat } from '@/content/hats';

let hideTimer: number | null = null;

export function showUnlockToast(hats: readonly Hat[]): void {
  if (hats.length === 0) return;
  const toast = $('toast');
  const title = $('toast-title');
  title.textContent = `the ${hats.map((h) => h.name).join(' & ')} hat`;
  toast.classList.add('visible');
  if (hideTimer !== null) window.clearTimeout(hideTimer);
  hideTimer = window.setTimeout(() => {
    toast.classList.remove('visible');
    hideTimer = null;
  }, 3200);
}
